import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

export const actionTypes = {
  SetLang: '[Set Lang] Action',
};

const initialState = {
  lang: 'en',
};

export const reducer = persistReducer(
  {
    storage,
    key: 'lang',
    whitelist: ['lang'],
  },
  (state = initialState, action) => {
    switch (action.type) {
      case actionTypes.SetLang: {
        const { lang } = action.payload;
        return { ...state, lang };
      }

      default:
        return state;
    }
  }
);

export const actions = {
  setLang: (lang) => ({
    type: actionTypes.SetLang,
    payload: { lang },
  }),
};
